import { cva } from '@/styled-system/css';

export const avatarRecipe = cva({
  base: {
    position: 'relative',
    maxWidth: '100%',
    aspectRatio: '1/1',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 'shape.ellipse',
    boxShadow: {
      base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
      _focusVisible: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
    },
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease',
    },
  },
  variants: {
    tone: {
      'default': {
        backgroundColor: 'Avatar.Root.bg',
        boxShadowColor: 'Avatar.Root.border',
        color: 'text.neutral',
      },
      'brand-hero': {
        backgroundColor: 'bg.accent.brand.hero',
        boxShadowColor: 'border.invisible',
        color: 'text.onHero.neutral',
      },
      'accent-1': {
        backgroundColor: 'bg.accent.blue.impact',
        boxShadowColor: 'border.invisible',
        color: 'text.onHero.neutral',
      },
      'accent-2': {
        backgroundColor: 'Avatar.Root.accent.2.bg',
        boxShadowColor: 'border.invisible',
        color: 'text.onHero.neutral',
      },
      'accent-3': {
        backgroundColor: 'Avatar.Root.accent.3.bg',
        boxShadowColor: 'border.invisible',
        color: 'text.onHero.neutral',
      },
      'accent-4': {
        backgroundColor: 'Avatar.Root.accent.4.bg',
        boxShadowColor: 'border.invisible',
        color: 'text.onHero.neutral',
      },
    },
    size: {
      xs: {
        textStyle: 'body-sm-bold',
        width: 'obj.xs',
        height: 'obj.xs',
      },
      sm: {
        textStyle: 'body-bold',
        width: 'obj.sm',
        height: 'obj.sm',
      },
      md: {
        textStyle: 'heading-xs',
        width: 'obj.md',
        height: 'obj.md',
      },
      lg: {
        textStyle: 'heading-sm',
        width: 'obj.lg',
        height: 'obj.lg',
      },
      xl: {
        textStyle: 'heading-md',
        width: 'obj.xl',
        height: 'obj.xl',
      },
      xxl: {
        textStyle: 'heading-lg',
        width: 'obj.xxl',
        height: 'obj.xxl',
      },
    },
  },
});
